export default {
  endpoints: {
    stitchBackend: "https://api.sandbox.withstitch.com",
    astraRedirect: "https://onboarding.sandbox.withstitch.com",
  },
  debug: false,
};
